export default __webpack_public_path__ + "static/media/phoneicon.c0234b17.svg";